"use strict";

angular.module('app.mainFrame.searchMenu.searchMenuService', [])
    .factory('app.mainFrame.searchMenu.searchMenuService', [
        function () {
            return {
                isExpanded: false
            };
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/searchMenu/searchMenuService.js